import moment from 'moment';
import recurssion from '../recurrence.json';

const weeksData = recurssion.days;

export const structure = (repeatEvery, data, endDate, startTime) => {
  // console.log('------------', repeatEvery, data, endDate)

  if (repeatEvery && repeatEvery?.type === 'DAILY') {
    return rruleDaily(repeatEvery, endDate);
  } else if (repeatEvery && repeatEvery?.type === 'WEEKLY') {
    return rruleWeekly(repeatEvery, data, endDate,startTime);
  } else if (repeatEvery && repeatEvery?.type === 'MONTHLY') {
    return rruleMonthly(repeatEvery, data, endDate);
  } else if (repeatEvery && repeatEvery?.type === 'YEARLY') {
    return rruleYearly(repeatEvery, data, endDate);
  }
};

const rruleDaily = (repeatEvery, endDate) => {
  let rrurle = '';
  if (repeatEvery?.type) {
    rrurle = `FREQ=${repeatEvery?.type}`;
  }
  if (repeatEvery?.on) {
    rrurle = `${rrurle};INTERVAL=${repeatEvery?.on}`;
  }
  if (endDate) {
    rrurle = `${rrurle};UNTIL=${convertDateToUTC(endDate)}`;
  }
  return rrurle;
};

const rruleWeekly = (repeatEvery, data, endDate,startTime) => {
  let rrurle = '';
  if (repeatEvery?.type) {
    rrurle = `FREQ=${repeatEvery?.type}`;
  }
  if (data && data?.length > 0) {
    const week = data;
    const final = [];
    weeksData.forEach((item) => {
      const n = week?.filter((val) => val === item.id);
      if (n.length > 0) {
        if (n[0] === item.id) {
          final.push(item.id);
        }
      }
    });
    rrurle = `${rrurle};BYDAY=${final.map((item) => item).join(',')}`;
  }
  if (repeatEvery?.on) {
    rrurle = `${rrurle};INTERVAL=${repeatEvery?.on}`;
  }
  if (endDate) {
    rrurle = `${rrurle};UNTIL=${convertDateToUTC(endDate,startTime)}`;
  }
  console.log(rrurle);
  return rrurle;
};

const rruleMonthly = (repeatEvery, data, endDate) => {
  if (data && data?.checkedBy === 'onday') {
    return mothlyByMonthDay(repeatEvery, data, endDate);
  } else if (data && data?.checkedBy === 'onthe') {
    return mothlyByDay(repeatEvery, data, endDate);
  }
};

const mothlyByMonthDay = (repeatEvery, data, endDate) => {
  let rrurle = '';
  if (repeatEvery?.type) {
    rrurle = `FREQ=${repeatEvery?.type}`;
  }
  if (data?.onDay) {
    rrurle = `${rrurle};BYMONTHDAY=${data?.onDay}`;
  }
  if (repeatEvery?.on) {
    rrurle = `${rrurle};INTERVAL=${repeatEvery?.on}`;
  }
  if (endDate) {
    rrurle = `${rrurle};UNTIL=${convertDateToUTC(endDate)}`;
  }
  return rrurle;
};

const mothlyByDay = (repeatEvery, data, endDate) => {
  let rrurle = '';
  if (repeatEvery?.type) {
    rrurle = `FREQ=${repeatEvery?.type}`;
  }
  if (data?.onthe?.day) {
    rrurle = `${rrurle};BYDAY=${data?.onthe?.day}`;
  }
  if (data?.onthe?.position) {
    rrurle = `${rrurle};BYSETPOS=${data?.onthe?.position}`;
  }
  if (repeatEvery?.on) {
    rrurle = `${rrurle};INTERVAL=${repeatEvery?.on}`;
  }
  if (endDate) {
    rrurle = `${rrurle};UNTIL=${convertDateToUTC(endDate)}`;
  }
  return rrurle;
};

const rruleYearly = (repeatEvery, data, endDate) => {
  if (data && data?.checkedBy === 'on') {
    return yearlyByMonthDay(repeatEvery, data, endDate);
  } else if (data && data?.checkedBy === 'onthe') {
    return yearlyByDay(repeatEvery, data, endDate);
  }
};

const yearlyByMonthDay = (repeatEvery, data, endDate) => {
  let rrurle = '';
  if (repeatEvery?.type) {
    rrurle = `FREQ=${repeatEvery?.type}`;
  }
  if (data?.on?.position) {
    rrurle = `${rrurle};BYMONTHDAY=${data?.on?.position}`;
  }
  if (data?.on?.month) {
    rrurle = `${rrurle};BYMONTH=${data?.on?.month}`;
  }
  if (repeatEvery?.on) {
    rrurle = `${rrurle};INTERVAL=${repeatEvery?.on}`;
  }
  if (endDate) {
    rrurle = `${rrurle};UNTIL=${convertDateToUTC(endDate)}`;
  }
  return rrurle;
};

const yearlyByDay = (repeatEvery, data, endDate) => {
  let rrurle = '';
  if (repeatEvery?.type) {
    rrurle = `FREQ=${repeatEvery?.type}`;
  }
  if (data?.onthe?.day) {
    rrurle = `${rrurle};BYDAY=${data?.onthe?.day}`;
  }
  if (data?.onthe?.position) {
    rrurle = `${rrurle};BYSETPOS=${data?.onthe?.position}`;
  }
  if (data?.onthe?.month) {
    rrurle = `${rrurle};BYMONTH=${data?.onthe?.month}`;
  }
  if (repeatEvery?.on) {
    rrurle = `${rrurle};INTERVAL=${repeatEvery?.on}`;
  }
  if (endDate) {
    rrurle = `${rrurle};UNTIL=${convertDateToUTC(endDate)}`;
  }
  return rrurle;
};

const convertDateToUTC = (date,startTime) => {
  // return date ? `${moment.utc(date).format('YYYYMMDDTHHmmss')}Z` : '';
  // const currentDate = new Date();
  // const currentTime = moment(currentDate).format('H:mm:ss');
  if (date) {
    date = moment(date + ' ' + startTime, 'YYYY-MM-DD H:mm:ss');
  }
  return date ? `${moment.utc(new Date(date)).format('YYYYMMDDTHHmmss')}Z` : '';
};
